import React from 'react'
import './tesimonials.css'


const testimonials = () => {
  return (
    <section id='testimonials'>
      {/* <h5>Review from clients</h5>
      <h2>Testimonials</h2>
      <div className="container testimonials__container">
        <article className="testimonial">
          <div className="client__avatar">
            <img src={AVTR1} alt="Avatar one" />
          </div>
        </article>
      </div> */}
    </section>
  )
}

export default testimonials